import clsx from 'clsx';
import React from 'react';

export const typographyClassName =
  'm-0 text-base font-normal leading-6 text-[#151515]';

type TextProps = React.HTMLAttributes<HTMLParagraphElement>;

export const Text: React.FC<TextProps> = ({ className, ...props }) => (
  <p
    className={clsx(typographyClassName, 'text-dim-300', className)}
    {...props}
  />
);
Text.displayName = 'Text';

export const Label: React.FC<TextProps> = ({ className, ...props }) => (
  <p className={clsx(typographyClassName, className)} {...props} />
);
Label.displayName = 'Label';

export const Value: React.FC<TextProps> = ({ className, ...props }) => (
  <p
    className={clsx(typographyClassName, 'text-dim-900', className)}
    {...props}
  />
);
Value.displayName = 'Value';

export const Error: React.FC<TextProps> = ({ className, ...props }) => (
  <p
    className={clsx(typographyClassName, 'text-red-600', className)}
    {...props}
  />
);
Error.displayName = 'Error';

export const Disclaimer: React.FC<TextProps> = ({ className, ...props }) => (
  <p
    className={clsx(typographyClassName, 'text-sm text-dim-900', className)}
    {...props}
  />
);
Disclaimer.displayName = 'Disclaimer';

type LabelValueProps = Pick<
  JSX.IntrinsicElements['div'],
  'className' | 'style'
> & {
  label: string;
  value: string | React.ReactNode;
};

export const LabelValue: React.FC<LabelValueProps> = ({
  label,
  value,
  className,
  ...props
}) => (
  <div
    className={clsx('flex w-full flex-col items-start', className)}
    {...props}
  >
    <Label>{label}</Label>
    {typeof value === 'string' ? <Value>{value}</Value> : <>{value}</>}
  </div>
);
LabelValue.displayName = 'LabelValue';

type LinkProps = Pick<
  JSX.IntrinsicElements['a'],
  'className' | 'href' | 'onClick'
>;

export const Link: React.FC<LinkProps> = ({ className, ...props }) => (
  <a
    className={clsx('cursor-pointer text-dim-900 underline', className)}
    {...props}
  />
);
Link.displayName = 'Link';

export const AccentLink: React.FC<LinkProps> = ({ className, ...props }) => (
  <a
    className={clsx('cursor-pointer text-primary no-underline', className)}
    {...props}
  />
);
AccentLink.displayName = 'AccentLink';
